<style scoped>
</style>

<template>
  <div class="navbar navbar-default navbar-fixed-top" role="navigation">
    <div class="container-fluid">
      <div class="navbar-header">
        <router-link to="/home" class="navbar-brand">通讯管理机</router-link>
      </div>
      <div class="navbar-collapse collapse" id="collapse">
        <ul class="nav navbar-nav navbar-right">
          <!-- <li class="dropdown user" v-if="auth && auth.username">
                    <a href="#" class="dropdown-toggle" @click.prevent>
                        <i class="fa fa-user"></i> {{auth.username}}
                    </a>
                </li> -->
          <li class="dropdown user">
            <a
              href="#"
              @click.prevent.stop="$emit('logout')"
              class="dropdown-toggle"
            >
              <i class="fa fa-sign-out"></i> 退出登录
            </a>
          </li>
          <li class="dropdown user">
            <router-link to="/log" class="dropdown-toggle">
              <i class="fa fa-file-text-o"></i> 运行日志
            </router-link>
          </li>
          <li class="dropdown user">
            <a
              href="#"
              @click.prevent.stop="store.showMessage"
              class="dropdown-toggle"
            >
              <i class="fa fa-headphones"></i> 报文解析
            </a>
          </li>
          <!-- <li class="dropdown user">
                    <a href="#" @click.prevent.stop="store.showPermission">
                        <i class="fa fa-unlock-alt"></i> 超级管理员
                    </a>
                </li> -->
          <!-- // END user -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "navbar",
  props: {
    store: null,
    auth: null,
  },
};
</script>



// WEBPACK FOOTER //
// Navbar.vue?2de9ec17